var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-dividends"},[_c('DividendsDetails',{staticClass:"section-margin"},[_c('MoreTitle',{attrs:{"title":"分红派息"}})],1),_c('FundSplit',[_c('MoreTitle',{attrs:{"title":"拆股并股"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }